declare global {
	interface Window {
		__PRELOAD_BOUNDARY_NAME__?: string;
	}
}

window.__PRELOAD_BOUNDARY_NAME__ = 'default';

export function beforePreloaderAsyncCall(): string {
	return window.__PRELOAD_BOUNDARY_NAME__ || 'default';
}

export function afterPreloaderAsyncCall(beforeResult?: string): void {
	window.__PRELOAD_BOUNDARY_NAME__ = beforeResult || 'default';
}
